module.exports = __webpack_public_path__ + "img/menu1.cf2d7772.png";